import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4a830f87")
const _hoisted_1 = { class: "alert-container" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertBubble = _resolveComponent("AlertBubble")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert) => {
      return (_openBlock(), _createBlock(_component_AlertBubble, {
        key: alert.id,
        kind: alert.type,
        message: alert.message,
        id: alert.id
      }, null, 8, ["kind", "message", "id"]))
    }), 128))
  ]))
}